module.exports = __webpack_public_path__ + "211d9a47dd19b2a3e258d08e9aea703a.png";